import {
  LMS_INIT_SUCCESS,
  LOAD_MORE_SUCCESS,
  FILTER_REQUEST_SUCCESS,
  SORT_SUCCESS,
} from '../constants';

const initialState = {
  offers: [],
};

const flightOfferReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LMS_INIT_SUCCESS:
    case FILTER_REQUEST_SUCCESS:
    case SORT_SUCCESS:
      return {
        ...state,
        offers: payload?.offers || [],
      };

    case LOAD_MORE_SUCCESS:
      return {
        ...state,
        offers: [...state.offers, ...(payload?.offers || [])],
      };

    default:
      return state;
  }
};

export default flightOfferReducer;
